import script from "./FooterInternationalamnesty.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterInternationalamnesty.vue?vue&type=script&setup=true&lang=js"

import "./FooterInternationalamnesty.vue?vue&type=style&index=0&id=6058af8a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6058af8a"]])

export default __exports__